import { createFileRoute } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { AssistantKnowledgeManager } from '@/features/organizations/settings/assistant-knowledge'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/assistant-knowledge'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: AssistantKnowledgePage,
})

function AssistantKnowledgePage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()

  if (isPending) {
    return (
      <Main>
        <div className="py-8 text-center">
          <p className="text-muted-foreground">Loading organization...</p>
        </div>
      </Main>
    )
  }

  return (
    <AssistantKnowledgeManager organizationId={activeOrganization?.id || ''} />
  )
}
